import { inject, injectable } from 'inversify';

import { TenantServiceClientAdapter } from '../../../Tenant/infrastructure/adapters/TenantServiceClientAdapter';
import { UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase } from '../../domain/abstract';
import { UserServiceClientAdapter } from '../../infrastructure/adapters/UserServiceClient.adapter';

@injectable()
export class UserTenantSpecificTenantAdminPolicyUpdateCommand extends UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase {
  constructor(
    @inject(UserServiceClientAdapter)
    private readonly userServiceClientAdapter: UserServiceClientAdapter,

    @inject(TenantServiceClientAdapter)
    private readonly tenantServiceClientAdapter: TenantServiceClientAdapter,
  ) {
    super();
  }

  public readonly execute: UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase['execute'] =
    async (userPrincipal, payload) => {
      this.validateUseCase(userPrincipal);

      const {
        userTenantSpecificRolesHandler,
        tenantSpecificTenantAdminPolicy,
      } = payload;

      const {
        composeUserTenantSpecificTenantAdminRoles,
        toUnifiedRoleCollectionDto,
      } = await userTenantSpecificRolesHandler.getUserTenantSpecificUnifiedRoles();

      const updatedTenantSpecificUserRoles =
        composeUserTenantSpecificTenantAdminRoles(
          tenantSpecificTenantAdminPolicy,
        );

      await userTenantSpecificRolesHandler.updateUserTenantSpecificUnifiedRoles(
        toUnifiedRoleCollectionDto(updatedTenantSpecificUserRoles),
      );
    };
}
